import { get } from 'helpers/api';
import { getImport } from '../selectors';
import { VERIFICATION_STATE } from '../../constants';
import { clearImportFiles, setImportStatusType } from './importer';
import { canSave, getImportRequest, getPaths } from '../selectors';

export const SET_VERIFICATION = 'importRequest/SET_VERIFICATION';
export const setVerification = verification => ({
  type: SET_VERIFICATION,
  verification
});

export const SET_VERIFICATION_STATE = 'importRequest/SET_VERIFICATION_STATE';
export const setVerificationState = state => ({
  type: SET_VERIFICATION_STATE,
  state
});

export const SET_VERIFICATION_PROGRESS = 'importRequest/SET_VERIFICATION_PROGRESS';
export const setVerificationProgress = progress => ({
  type: SET_VERIFICATION_PROGRESS,
  progress
});

export const SET_VERIFICATION_LABELS = 'importRequest/SET_VERIFICATION_LABELS';
export const setVerificationLabels = labels => ({
  type: SET_VERIFICATION_LABELS,
  labels
});

export const SET_PREPROCESS_RUNNING = 'importRequest/SET_PREPROCESS_RUNNING';
export const setPreprocessRunning = preprocessRunning => ({
  type: SET_PREPROCESS_RUNNING,
  preprocessRunning
});

export const startPreprocessImport = () => (
  (dispatch, getState) => {
    const state = getState();
    if (!canSave(state)) return;

    const paths = getPaths(state);
    const importRequest = getImportRequest(state);
    setPreprocessRunning(false);
    dispatch(clearImportFiles());

    return get(`${paths.importRequest}/${importRequest.id}/preprocess`)
      .then(() => {
        dispatch(setPreprocessRunning(false));
      }).catch((errors) => {
        dispatch(setVerificationState(VERIFICATION_STATE.PREPROCESS_FAIL));
        dispatch(setVerificationLabels({
          progressing: 'Unable to verify.'
        }));
        dispatch(setVerification({
          errors
        }));  
      });
  }
);

export const getValidationState = (expectedStatuses, successMessages) => (
  (dispatch, getState) => {
    const state = getState();
    if (!canSave(state)) return;

    const paths = getPaths(state);
    const importRequest = getImportRequest(state);

    return get(`${paths.importRequest}/${importRequest.id}/status`)
      .then((response) => {
        if (response.complete === response.total) {
          dispatch(setVerificationState(VERIFICATION_STATE.SUCCESS));
          dispatch(setVerificationLabels(successMessages));
          dispatch(setImportStatusType('mapping_files'));
        } else {
          dispatch(setVerificationState(VERIFICATION_STATE.IN_PROGRESS));
          dispatch(setVerificationProgress(Math.round(response.complete / response.total * 100)));
        }
      }).catch(() => {
        dispatch(setVerificationState(VERIFICATION_STATE.FAIL));
        dispatch(setVerificationLabels({
          progressing: 'The import has been stopped due to a network error. Reload the page to try again.'
        }));
      });
  }
);

export const refreshVerificationStatus = (expectedStatuses, successMessages) => (
  (dispatch, getState) => {
    const state = getState();
    const importer = getImport(state);

    get(`${importer.runPath}/status`).then((response) => {
      const { complete, total } = response;
      if (expectedStatuses.includes(response.status)) {
        dispatch(setVerificationState(VERIFICATION_STATE.SUCCESS));
        dispatch(setVerificationLabels(successMessages));
        dispatch(setImportStatusType(response.status));
      } else {
        let status = 0;
        if (total > 0 && complete > 0) {
          status = (parseFloat(complete) / parseFloat(total)) * 100;
        }
        dispatch(setVerificationState(VERIFICATION_STATE.IN_PROGRESS));
        dispatch(setVerificationProgress(parseInt(status)));
      }
    }).catch(() => {
      dispatch(setVerificationState(VERIFICATION_STATE.FAIL));
      dispatch(setVerificationLabels({
        progressing: 'The import has been stopped due to a network error. Reload the page to try again.'
      }));
    });
  }
);
